import {
  FullLogo,
  loadingImage,
  WilsonFullLogo,
  WilsonSidebarLogo,
  wilsonFavicon,
} from '@revelio/assets';

import { RevelioWatermark, WilsonWatermark } from './assets';
import wilsonFullLogoImage from './assets/images/wilson/full-logo.svg';
import wilsonCoverLandscape from './assets/images/wilson/ppt-cover.png';
import wilsonCoverPortraitPpt from './assets/images/wilson/report-cover.png';
import wilsonCoverPortrait from './assets/images/wilson/report-cover.svg';
import rlLogoImage from './images/rl-logo.svg';
import { RevelioSidebarLogo } from './next/routes/side-nav/Logo';
import { registerBrand } from './shared/branding/brand-config';

/**
 * Register all brand configurations at app startup.
 * Add new client brands here.
 */

registerBrand('default', {
  clientName: 'default',
  displayName: 'Revelio Labs',
  loadingGif: loadingImage,
  primaryColor: {
    50: '#EBF9F1',
    100: '#D8F3E4',
    200: '#B0E8C8',
    300: '#89DCAD',
    400: '#65D294',
    500: '#3DC679',
    600: '#2FA261',
    700: '#237647',
    800: '#174F2F',
    900: '#0C2718',
  },
  sidebarColor: {
    50: '#E6EBF4',
    100: '#CDD7EA',
    200: '#9BAFD4',
    300: '#6987BF',
    400: '#43639E',
    500: '#2D426A',
    600: '#243656',
    700: '#1B2840',
    800: '#121B2B',
    900: '#090D15',
  },
  logos: {
    sidebarLogo: RevelioSidebarLogo,
    fullLogo: FullLogo,
    reportLogo: rlLogoImage,
    watermark: RevelioWatermark,
    favicon: 'assets/favicon.png',
  },
});

// Wilson Analytics Dashboard — shared config for all Wilson client groups
const wilsonSharedConfig = {
  displayName: 'Wilson Analytics Dashboard',
  primaryColor: '#16170F',
  sidebarColor: '#00ae8a',
  textColor: '#16170F',
  logos: {
    sidebarLogo: WilsonSidebarLogo,
    fullLogo: WilsonFullLogo,
    reportLogo: wilsonFullLogoImage,
    watermark: WilsonWatermark,
    favicon: wilsonFavicon,
  },
  chartColors: [
    '#00ae8a',
    '#fc9d55',
    '#91ebc9',
    '#2b9cbc',
    '#00725d',
    '#f98686',
    '#d82e2e',
    '#ac8761',
    '#555baa',
    '#d83f84',
    '#ffcda6',
    '#8dc9da',
    '#f6b8b8',
    '#e56e6e',
    '#c6aa8e',
    '#979fcc',
    '#fc97c5',
    '#999999',
  ],
  otherColor: '#999999',
  coverImagePortrait: wilsonCoverPortrait,
  coverImagePortraitPpt: wilsonCoverPortraitPpt,
  coverImageLandscape: wilsonCoverLandscape,
  coverBackgroundColor: '#91ebc9',
  coverTitleColor: '#16170F',
  coverDescriptionColor: '#16170F',
};

registerBrand('Wilson HR', {
  clientName: 'Wilson HR',
  ...wilsonSharedConfig,
});

registerBrand('Wilson HCG', {
  clientName: 'Wilson HCG',
  ...wilsonSharedConfig,
});

registerBrand('Wilson_SuperUsers', {
  clientName: 'Wilson_SuperUsers',
  ...wilsonSharedConfig,
});
